<template>
  <template v-if="Array.isArray(normalizedNodes)">
    <component v-for="(node, index) in normalizedNodes" :key="index" :is="node" />
  </template>
  <component v-else :is="normalizedNodes" />
</template>

<script lang="ts" setup>
import { computed, h } from 'vue';

const props = defineProps<{
  nodes: string | object | any[];
}>();

const normalizedNodes = computed(() => {
  if (typeof props.nodes === 'string') {
    return h('span', { innerHTML: props.nodes });
  }

  return props.nodes;
});
</script>
